import React from 'react'
import Loadable from 'Components/LoadableToImported'

const MlsDisclaimer = Loadable({
  loader: () => import(/* webpackChunkName: "MlsDisclaimer" */ './MlsDisclaimer'),
  loading: () => <div />,
  chunkName: 'MlsDisclaimer',
})

export default MlsDisclaimer
